import NativeSelect from '@mui/material/NativeSelect';
import i18n from '@shared/config/i18n';
import * as Styled from './styled';

const { t } = i18n;

export const FilterSelect = ({
  field: { value },
  onChange,
  label,
  list,
  noDefault = false,
}) => (
  <Styled.FormControl>
    <Styled.FieldTitle>{label}</Styled.FieldTitle>
    <NativeSelect
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      input={<Styled.BootstrapInput />}
    >
      {!noDefault && (
        <option aria-label="None" value="">
          {t('all')}
        </option>
      )}

      {list.map((item) => (
        <option key={item.id} value={item.id}>
          {item.title}
        </option>
      ))}
    </NativeSelect>
  </Styled.FormControl>
);
